const mergeOverrideTypePolicy: MergeOverrideTypePolicy = {
  merge(existing: MergeOverrideTypeItem[], incoming: MergeOverrideTypeItem[]): MergeOverrideTypeItem[] {
    return [...incoming];
  },
};

export default mergeOverrideTypePolicy;
